import { render } from "./PubDetails.vue?vue&type=template&id=3a885be6"
import script from "./PubDetails.vue?vue&type=script&lang=js"
export * from "./PubDetails.vue?vue&type=script&lang=js"
script.render = render

export default script